export type GetDearProductsPayload = {
  productCategories: string[]
  currency?: string
}

export type DearProduct = {
  Name: string
  SKU: string
  PriceTier1: number
  Currency: string
  [key: string]: any // if needed
}

export type GetDearProductsResponse = {
  products: DearProduct[]
  errors: string[] // could be empty
}

export async function getDearProducts({
  productCategories,
  currency = 'usd',
}: GetDearProductsPayload): Promise<GetDearProductsResponse> {
  const res = await fetch(import.meta.env.VITE_WEBHOOKS_URL + '/get-dear-products', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ productCategories, currency }),
  })

  const json = await res.json()

  const status = res.status

  if (!res.ok || status >= 400) {
    const errorMessages =
      json?.data?.errors?.join('; ') || json?.message || 'Something went wrong'
    throw new Error(errorMessages)
  }

  const products = json?.data?.Products ?? []
  const errors = json?.data?.errors ?? []

  return { products, errors }
}

